module.exports = __webpack_public_path__ + "img/tutorial_suitcase_01.67df19c7.png";